var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-accordion',{attrs:{"title":_vm.data.title,"content":_vm.faqItems,"background-color":_vm.blockColor}})}
var staticRenderFns = []

export { render, staticRenderFns }